import React from "react";
import { Image } from "react-bootstrap";
import { Link } from "react-router-dom";
import SubscribeNewsletter from "../../pages/Home/SubscribeNewsletter";
import MetaData from "../../components/layout/MetaData";

const OdmServicesScreen = () => {
  return (
    <>
      <MetaData title="ODM Services" />
      <section className="p-8">
        <div className="flex flex-col justify-center items-center px-8 my-8 w-full md:w-1/2">
          <h2 className="text-2xl font-bold">
            End-to-End Turnkey
            <br />
            Product Services
          </h2>
          <p>
            Tap into our years of ODM Experience to ideate, design, prototype
            and bring your product to the rest of the world
          </p>
        </div>
        <div className="flex justify-center items-center">
          <Image
            className="shadow-lg"
            src="/img/roadmap.webp"
            alt="ODM Services Roadmap"
          />
        </div>
      </section>

      <section className="p-4 border-t border-gray-200">
        <div className="flex flex-col md:flex-row">
          <Image
            className="w-full md:w-1/2 p-4"
            src="/img/planning_section.png"
            alt="Planning Section"
          />
          <div className="flex flex-col justify-center px-8 my-8 md:w-1/2">
            <h3 className="text-xl font-semibold">Planning Phase</h3>
            <p>
              Embark on our structured Planning Phase, designed to facilitate
              your product's seamless development. We commence with a
              personalized call, delving into your project requirements for a
              comprehensive grasp of your unique vision. Prioritizing
              confidentiality, we formalize security measures by signing
              Non-Disclosure Agreements (NDAs) and seamlessly receiving any
              project-specific files. We conduct an in-depth project analysis,
              identifying potential challenges/bottlenecks and outlining a
              strategic roadmap for a clear trajectory.
            </p>
            <p>
              Next, we transparently generate a detailed quotation based on your
              Request for Quotation (RFQ), providing insights into timelines and
              project scope. Engaging in collaborative discussions about
              commercials, we ensure alignment with your budgetary
              considerations. We then sign agreements structured around a
              milestone-based delivery schedule. This milestone-driven approach
              ensures efficiency and clarity, guiding your product development
              journey from concept to reality.
            </p>
          </div>
        </div>
      </section>

      <section className="p-4 border-t border-gray-200">
        <div className="flex flex-col md:flex-row">
          <Image
            className="w-full md:w-1/2 p-4"
            src="/img/engineering_section.png"
            alt="Engineering Section"
          />
          <div className="flex flex-col justify-center px-8 my-8 md:w-1/2">
            <h3 className="text-xl font-semibold">Engineering Phase</h3>
            <p>
              In the mechanical design phase, we start by engaging in a dynamic
              brainstorming session with your design team, aiming to extract
              every nuance of your product vision. Sketching up concept models,
              we bring ideas to life visually. Once a design direction is
              chosen, we proceed to craft detailed mockup models, refining them
              based on your preferences. The final touch involves meticulous
              mechanical design and product 3D CAD modeling, ensuring precision
              and manufacturability.
            </p>
          </div>
        </div>
      </section>

      <section className="p-4 border-t border-gray-200">
        <div className="flex flex-col md:flex-row">
          <Image
            className="w-full md:w-1/2 p-4"
            src="/img/prototyping_section.png"
            alt="Prototyping Section"
          />
          <div className="flex flex-col justify-center px-8 my-8 md:w-1/2">
            <h3 className="text-xl font-semibold">Prototyping Phase</h3>
            <p>
              In the Prototyping Phase, we make rough mockups of the mechanical
              structure of your product with in-house precise 3D printers
              capable of supporting multiple types of materials for your desired
              application. These are shipped to the client for tangible
              evaluations. We work closely with our ecosystem partners to
              facilitate high-density, multi-layer, impedance-controlled PCB
              manufacturing followed by PCB assembly with Automated optical
              inspection and testing.
            </p>
          </div>
        </div>
      </section>

      <h3 className="text-center my-10 text-xl font-semibold">
        Reach out to us for a quote today at{" "}
        <Link
          className="text-blue-500 hover:text-blue-700"
          href="mailto:hello@creatyea.com"
        >
          hello@creatyea.com
        </Link>
      </h3>

      <SubscribeNewsletter />
    </>
  );
};

export default OdmServicesScreen;
